import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, NavigationEnd } from '@angular/router';
import { Observable } from 'rxjs';
import { OauthService } from './oauth.service';
import { permission } from '../_helpers/access.control';

@Injectable({
  providedIn: 'root'
})

export class AuthGuard implements CanActivate {
  public currentUrl = '';
  accessArr: any;
  constructor(private _authService: OauthService,
    private _router: Router) {
    _router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.currentUrl = event.url;
        this.checkAuthorization(this.currentUrl);
      }
    });
  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (this._authService.loggedIn()) {
      return true;
    } else {
      this._router.navigate(['/login']);
      return false;
    }
  }

  checkAuthorization(currentUrl) {
    const username = sessionStorage.getItem('username');
    if(username != null){
      this.accessArr = permission.accessible[username];
      if (typeof this.accessArr[0] !== 'undefined' && this.accessArr[0] === 'all') {
        return true;
      } else {
        const noSlashesUrl = currentUrl.replace('/', '');
        const found = this.accessArr.find(function (element) {
          return element === noSlashesUrl;
        });
        if (typeof found === 'undefined') {
          this._router.navigate([this.accessArr[0]]);
        } else {
          return true;
        }
      }
    }
  }
}
